// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router/index';
import store from './store/index'
import moment from './plugins/moment'
import vmodal from 'vue-js-modal'
import {httpPlugin} from './lib/http'
import VueTouch from 'vue-touch'
// import {ServerTable, ClientTable, Event} from 'vue-tables-2';

// import vmodal from 'vue-js-modal'

window._ =  require('lodash');

window.vex = require('vex-js')
vex.registerPlugin(require('vex-dialog'))
vex.defaultOptions.className = 'vex-theme-plain'
Vue.use(VueTouch, { name: 'v-touch' });

Vue.component('spinner', require('./plugins/Spinner.vue'));
Vue.component('informator', require('./plugins/Informator.vue'));
Vue.component('user-panel', require('./components/UserPanel.vue'));

// import popper from 'vue-popperjs';
// Vue.component('popper', Object.assign(popper, { name: 'popper'}))

Vue.directive('hover', {
  // When the bound element is inserted into the DOM...
  inserted: function (el, binding) {
    // Focus the element
    el.addEventListener("mouseover", binding.value);
    el.addEventListener("mouseout", binding.value);
    console.log('bind', binding)
  },

  unbind: function (el, binding) {
    el.removeEventListener('mouseover', binding.value)
    el.removeEventListener('mouseout', binding.value)
  }
});

Vue.directive('action', {
  bind: (el, binding, { context }) => {
    let action = binding.expression;


    if (context.$can('accounts:'+action)) {
      el.addEventListener('click', () => {
        binding.value();
      })
    } else {
      el.style.display = 'none'
    }
  }
});


Vue.use(moment)
Vue.use(vmodal)
Vue.use(httpPlugin)
// Vue.use(ClientTable);

import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

// import VueSimplemde from 'vue-simplemde'
// Vue.use(VueSimplemde)

import dialog from './plugins/dialog'
Vue.use(dialog)

import maha from './plugins/super'
Vue.use(maha)

import security from './plugins/security'
Vue.use(security);

// import flatPickr from 'vue-flatpickr-component';
// import 'flatpickr/dist/flatpickr.css';
// Vue.component('datepicker', flatPickr);

Vue.filter('striphtml', function (value) {
    let div = document.createElement("div");
    div.innerHTML = value;
    return div.textContent || div.innerText || "";
});



// import VueKindergarten from 'vue-kindergarten';

Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})

Vue.filter('limit', function(array, length) {
  var limitCount = parseInt(length, 10);
  if (limitCount <= 0) {
    ("development") !== 'production' && _.warn(
        'The limit filter requires an argument defining the limit count.'
    );
    return array;
  }
  return array.slice(0, limitCount);
});

// todo: use this https://github.com/declandewet/vue-meta

Vue.config.devtools = process.env.NODE_ENV === 'development';

/* eslint-disable no-new */
window.vi = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  mounted() {
  }
});



// WEBPACK FOOTER //
// ./src/main.js